export const allowedProdTenants = ["envana", "catalyst_sandbox", "catalyst_sales", "fpt_qa"];

// Two roles exist: admin and viewer. Admin has full permissions in every environment,
// viewer can only ever read. The role comes from the authenticated Auth0 email (see
// roleForEmail in env_config), not from anything the user typed.
export const isViewer = (user) => user?.role === "viewer";
export const isAdmin = (user) => user?.role === "admin";

export const isProd = (env) => env === "prod" || env === "apProd";
export const isDev = (env) => env === "dev" || env === "qa" || env === "mvp";

// Viewer is read-only in every environment, so this no longer varies by environment.
// It stays a separate name from isViewer because the call sites are asking about the
// capability, not the role.
export const isViewOnly = (user) => isViewer(user);

export const awsRegions = ["us-east-1", "us-east-2", "us-west-1", "us-west-2", "ap-southeast-1", "ap-southeast-2"];
